<template>
  <div class="w100">
    <div class="lv_nav flex">
      <div class="logo">
        <img src="../../../assets/base/logo_sample.png" />
      </div>
      <div class="navlist flex_start">
        <div
          class="navitem"
          v-for="(item, index) in navlist"
          :key="index"
          :class="{ navitemac: activerouter(item.path) }"
        >
          <span @click="tojump(item.path)"> {{ item.name }} </span>
          <div class="navchild flex_start wrap" v-if="item.navchild">
            <div
              class="navchilditem"
              v-for="(childitem, childindex) in item.navchild"
              :key="childindex"
              @click="tojump(childitem.path)"
            >
              <div class="kk flex_start">
                <svg-icon :icon-class="childitem.icon" class="colmnicon" />
                <div class="colmntxt">
                  <h3 v-if="childitem.name">{{ childitem.name }}</h3>
                  <h4 v-if="childitem.des">{{ childitem.des }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="navright flex_end" @mouseout="mout">
        <div
          class="search"
          :class="{ sea11: seashow }"
          @mouseout.stop=""
          @mouseover="mover"
        >
          <svg-icon icon-class="fdj_search" />
          <div class="seachild" @mouseout.stop="mout">
            <div class="scssk flex_start">
              <input
                type="text"
                v-model="seavalue"
                placeholder="在此输入搜索内容"
              />
              <div class="ssanbtn">搜索</div>
            </div>
            <div class="rdym flex_start">
              <div class="rdymitem">大家都在搜:</div>
              <div
                class="rdymitem"
                v-for="(item, index) in dzslist"
                :key="index"
                @click="seavalue = item"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="online_btn" @click="tojump('/question/onlitform')">
          在线咨询
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navlist: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "法律咨询",
          path: "/question",
          navchild: [
            {
              name: "在线咨询",
              des: "我热爱咨询热啊咨询",
              icon: "nav_zxzx",
              path: "/question/lawyeronline",
            },
            {
              name: "一对一咨询",
              icon: "nav_ydyzx",
              des: "我热爱咨询热啊咨询",
              path: "/question/case",
            },
            {
              name: "电话咨询",
              icon: "nav_dhzx",
              des: "我热爱咨询热啊咨询",
              path: "/question/telzx",
            },
            {
              name: "案件委托",
              icon: "nav_ajwt",
              des: "我热爱咨询热啊咨询",
              path: "/question/entrust",
            },
            {
              name: "热门咨询",
              icon: "nav_rmzx",
              des: "我热爱咨询热啊咨询",
              path: "/question/hotconsult",
            },
          ],
        },
        {
          name: "找律师",
          path: "/findLawyers",
          navchild: [
            {
              name: "按地区找律师",
              icon: "nav_dq",
              path: "/findLawyers/city",
            },
            {
              name: "按专业找律师",
              icon: "nav_zy",
              path: "/findLawyers/field",
            },
            {
              name: "按律所找律师",
              icon: "nav_ls",
              path: "/findLawyers/lawyeroffice",
            },
            {
              name: "按问题找律师",
              icon: "nav_wt",
              path: "/findLawyers/ls",
            },
            {
              name: "按行业找律师",
              icon: "nav_hy",
              path: "/findLawyers/hangye",
            },
          ],
        },
        {
          name: "法律知识",
          path: "/laws",
          navchild: [
            {
              name: "法律聚焦",
              icon: "nav_fljj",
              path: "/laws/special",
            },
            {
              name: "视频说法",
              icon: "nav_spsf",
              path: "/laws/videoclaim",
            },
            {
              name: "音频说法",
              icon: "nav_ypsf",
              path: "/laws/audioclaim",
            },
            {
              name: "律师解答",
              icon: "nav_lsjd",
              path: "/laws/articleclaim",
            },
          ],
        },
        {
          name: "精品栏目",
          path: "/jpcol",
          navchild: [
            {
              name: "法律条例",
              icon: "nav_fltl",
              path: "/jpcol/tiaoli",
            },
            {
              name: "罪名库",
              icon: "nav_zmk",
              path: "/jpcol/zuiming",
            },
            {
              name: "解决方案",
              icon: "nav_jjfa",
              path: "/jpcol/fangan",
            },
            {
              name: "合同范本",
              icon: "nav_htfb",
              path: "/jpcol/contractmodel",
            },
            // {
            //   name: "实用计算器",
            //   icon: "nav_jsj",
            //   path: "/jpcol/DeskCalc",
            // },
          ],
        },
        // {
        //   name: "公司法务",
        //   path: "",
        // },
      ],
      sealist: ["找律师", "找律所", "找法规", "找罪名"],
      seatype: 0,
      seavalue: null,
      dzslist: ["找律师", "免费法律咨询", "罪名库", "法律常识"],
      seashow: false,
    };
  },
  methods: {
    seacli(index) {
      console.log(index);
      this.seatype = index;
    },
    activerouter(url) {
      if (url == "/" || !url) return;
      let ind = this.$route.path.indexOf(url);
      if (ind != -1) return true;
      else return false;
    },
    tojump(path) {
      if (path == "/jpcol"){ this.$router.push('/jpcol/tiaoli'); return;}
      this.$router.push(path);
    },
    mout() {
      this.seashow = false;
    },
    mover() {
      this.seashow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.w100 {
  width: 100%;
  height: 90px;
  background-color: #fff;
}
.lv_nav {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  .logo {
    width: 230px;
    height: 90px;
    line-height: 90px;
    img {
      width: 146px;
    }
  }
  .navlist {
    width: 710px;
    width: 600px;
    padding-left: 30px;

    .navitem {
      padding: 32px 10px;
      margin-right: 20px;
      font-size: 20px;
      color: #000000;
      > span {
        cursor: pointer;
      }
      .navchild {
        visibility: hidden;
        opacity: 0;
        z-index: 999;
        width: 100%;
        position: absolute;
        top: 110px;
        left: 0;
        padding: 0 30px 30px;
        background-color: #fff;
        box-shadow: 0px 10px 14px 0px rgba(0, 0, 0, 0.04);
        .navchilditem {
          margin-top: 30px;
          padding: 0 10px;
          width: 25%;
          .kk {
            cursor: pointer;
            width: 100%;
            height: 100%;
            border: 1px solid #f3f3f3;
            padding: 30px;
            align-items: flex-start;
            &:hover {
              background-color: #0465ea;
              box-shadow: 0 8px 12px 0 rgba($color: #0465ea, $alpha: 0.1);
              .colmnicon,
              h3,
              h4 {
                color: #fff;
              }
            }
            .colmnicon {
              font-size: 28px;
              margin-right: 15px;
              color: #0465ea;
            }
            h3 {
              font-size: 16px;
              color: #333;
            }
            h4 {
              margin-top: 10px;
              font-size: 14px;
              color: #888;
              font-weight: normal;
            }
          }
        }
      }
      &:hover {
        color: #0465ea;
        padding: 32px 10px 28px;
        border-bottom: 4px solid #0465ea;
        .navchild {
        transition: all 0.3s;
          visibility: visible;
          opacity: 1;
          top: 90px;
        }
      }
      &.navitemac {
        color: #0465ea;
        padding: 32px 10px 28px;
        border-bottom: 4px solid #0465ea;
      }
    }
  }
  .navright {
    flex: 1;
    height: 100%;
    .search {
      color: #333;
      padding: 0 28px;
      font-size: 22px;
      line-height: 90px;
      text-align: right;
      .seachild {
        visibility: hidden;
        position: absolute;
        left: 0;
        top: 100px;
        z-index: 999;
        width: 100%;
        font-size: 16px;
        line-height: 16px;
        padding-bottom: 20px;
        padding-top: 15px;
        background-color: rgb(255, 255, 255);
        border-bottom: 1px solid #dddddd;
        box-shadow: 0px 10px 14px 0px rgba(0, 0, 0, 0.08);
        .scssk {
          width: 680px;
          margin: 0 auto;
          text-align: left;
          padding-left: 105px;
          input {
            width: 325px;
            padding: 6px;
            border: none;
            outline: none;
            border-bottom: 1px solid #dddddd;
          }
          .ssanbtn {
            background-color: #a3a3a3;
            color: #fff;
            text-align: center;
            width: 84px;
            height: 26px;
            line-height: 26px;
            font-size: 14px;
            margin-left: 10px;
            border-radius: 4px;
            cursor: pointer;
          }
        }
        .rdym {
          padding-left: 105px;
          width: 680px;
          height: 20px;
          margin: 10px auto 0;
          .rdymitem {
            cursor: pointer;
            font-size: 14px;
            color: #666666;
            margin-right: 30px;
          }
        }
      }
      
      &.sea11 {
        .seachild {
          transition: all 0.3s;
          visibility: visible;
          opacity: 1;
          top: 90px;
        }
      }
      // &:hover {
      //   .seachild {
      //     transition: all 0.3s;
      //     visibility: visible;
      //     opacity: 1;
      //     top: 90px;
      //   }
      // }
    }
    .online_btn {
      background-color: #0465ea;
      color: #fff;
      text-align: center;
      width: 84px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
      border-radius: 20px;
    }
  }
}
</style>